"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const lodash_1 = require("lodash");
const ButtonDropdown_1 = tslib_1.__importDefault(require("../dropdown/ButtonDropdown"));
const TreeOptions = props => {
    const { treeOptions, className } = props;
    if ((0, lodash_1.isEmpty)(treeOptions)) {
        return null;
    }
    const dropdownClasses = (0, classnames_1.default)('display-flex flex-column gap-10', 'width-250', 'padding-15', className);
    const customDropdown = (0, jsx_runtime_1.jsx)("div", Object.assign({ className: dropdownClasses }, { children: treeOptions }));
    return ((0, jsx_runtime_1.jsx)(ButtonDropdown_1.default, { title: (0, jsx_runtime_1.jsx)("span", { className: 'rioglyph rioglyph-option-vertical', "aria-hidden": 'true' }), bsStyle: 'muted', customDropdown: customDropdown, className: 'TreeHeaderOptions', pullRight: true, iconOnly: true }));
};
TreeOptions.displayName = 'TreeOptions';
TreeOptions.defaultProps = {
    treeOptions: [],
};
TreeOptions.propTypes = {
    treeOptions: prop_types_1.default.arrayOf(prop_types_1.default.node),
    className: prop_types_1.default.string,
};
exports.default = TreeOptions;
